import { Typography, Grid, Card} from '@mui/material'
import React from 'react'

function Transaction(props) {
 if (props.check===true){
  return (
      <Grid id={props.id} container marginTop={1} spacing={1}>
            <Grid item xs={3}>
              <Card sx={{bgcolor:'green',color:'white'}}>
              <Typography variant='h5' textAlign='center'>₹{props.val[1]}</Typography>
              </Card>
            </Grid>
            <Grid item xs>
              <Card>
              <Typography variant='h5'>{props.val[0]}</Typography>
              </Card>
            </Grid>
      </Grid>
  )}
  else {
    return(
      <Grid id={props.id} container marginTop={1} spacing={1}>
            <Grid item xs={3}>
              <Card sx={{bgcolor:'red',color:'white'}}>
              <Typography variant='h5' textAlign='center'>₹{props.val[1]}</Typography>
              </Card>
            </Grid>
            <Grid item xs>
              <Card>
              <Typography variant='h5'>{props.val[0]}</Typography>
              </Card>
            </Grid>
        </Grid>
    )}
}

export default Transaction